// BI page identity for the WhatsApp screen and its side panels.
export const WHATSAPP_PAGE = { page_name: 'settings_whatsapp_page' as const, origin: 'dashboard' as const };

// The Symphony business WhatsApp number the "Open WhatsApp" CTA deep-links to
// (wa.me/<number>) — the 1:1 direct-chat entry point.
export const WHATSAPP_DIRECT_URL = 'https://wa.me/15188556881';

// Mirrors MAX_LIVE_GROUPS_PER_OWNER in common-lib's WaGroupOrchestrator (kept in lockstep
// with the native mirrors). The server is the enforcer — this only gates the "New group"
// button + hint.
export const MAX_LIVE_GROUPS = 3;

// Mirrors MAX_GROUP_PARTICIPANTS in common-lib's WaGroupOrchestrator. Informational only:
// members join via the invite link, so this is the number the hint quotes.
export const MAX_GROUP_PARTICIPANTS = 8;
